import verify2FACodeComponent from './verify_2FA_code.component';

let verify2FACodeModule = angular.module('verify2FACode', [
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/verify');

    $stateProvider
      .state('verify_2FA_code', {
        url: '/verify',
        component: 'verify2FACode',
        data: {
          requireLogin: false
        },
        params: {
          userId: null
        }
      });
  })

  .component('verify2FACode', verify2FACodeComponent)

  .name;

export default verify2FACodeModule;


// WEBPACK FOOTER //
// ./client/app/components/verify_2FA_code/index.js